import { keyBy } from "lodash-es";
import { propPanelMixin } from '../../../../helpers';
import EventCard from "./EventCard";
import { getComponentEventDeclarations } from '../../../../renderer/utils';
const __script_base__ = {
  name: 'EventCardList',
  mixins: [propPanelMixin],
  props: {
    showAddButton: {
      type: Boolean,
      default: true
    },
    showList: {
      type: Boolean,
      default: true
    }
  },
  components: {
    EventCard
  },
  methods: {
    removeEventKey(key) {
      this.modifyComp(c => {
        delete c.events[key];
      });
    },
    handleEventChange(eventKey, value) {
      this.modifyComp(c => {
        c.events[eventKey] = value;
      });
    },
    async addEvent(key) {
      if (!key) return;
      await this.modifyComp(c => {
        c.events = {
          ...c.events,
          [key]: {
            steps: []
          }
        };
      });
      this.$emit('change');
    },
    async changeEvent(key, oldKey) {
      if (!key || !oldKey) return;
      await this.modifyComp(c => {
        this.$set(c.events, key, c.events[oldKey]);
        this.$delete(c.events, oldKey);
        console.log(c);
      });
      this.$emit('change');
    }
  },
  computed: {
    currentEvents() {
      // 可能一开始没有comp.events 这个地方就收集不到变更
      return this.comp.events || {};
    },
    flowCtxBase() {
      var _this$designer$render;
      return (_this$designer$render = this.designer.renderer) === null || _this$designer$render === void 0 ? void 0 : _this$designer$render.getSimpleFlowCtxBaseOf(this.compPath);
    },
    eventDict() {
      return keyBy(this.eventList, 'id');
    },
    eventList() {
      const {
        renderer
      } = this.designer;
      if (!renderer) return [];
      return getComponentEventDeclarations(renderer, this.compPath);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [!_vm.eventList.length && _vm.showAddButton ? _c("div", {
    staticClass: "ucd-eventPanel-noEventPlaceholder"
  }, [_vm._v("\n    此组件不支持定义事件\n  ")]) : _c("div", {
    staticClass: "ucd-eventPanel-eventCardList"
  }, [_vm.showList ? _c("div", _vm._l(_vm.currentEvents, function (eventFlow, eventKey) {
    return _c("EventCard", {
      key: eventKey,
      attrs: {
        "flow-ctx-base": _vm.flowCtxBase,
        value: eventFlow,
        "event-meta": _vm.eventDict[eventKey],
        "event-key": eventKey,
        changeable: _vm.eventList.length > 1
      },
      on: {
        change: function ($event) {
          return _vm.handleEventChange(eventKey, $event);
        },
        delete: function ($event) {
          return _vm.removeEventKey(eventKey);
        }
      },
      scopedSlots: _vm._u([{
        key: "eventList",
        fn: function () {
          return _vm._l(_vm.eventList, function (event) {
            return _c("a-menu-item", {
              key: event.id,
              attrs: {
                disabled: event.id in _vm.currentEvents
              },
              on: {
                click: function () {
                  return _vm.changeEvent(event.id, eventKey);
                }
              }
            }, [_vm._v("\n            " + _vm._s(event.name) + "\n          ")]);
          });
        },
        proxy: true
      }], null, true)
    });
  }), 1) : _vm._e(), _vm._v(" "), _vm.showAddButton ? _c("div", {
    staticClass: "ucd-eventCard-addBox",
    staticStyle: {
      display: "flex",
      "justify-content": "space-around"
    }
  }, [_c("a-dropdown", {
    attrs: {
      "overlay-class-name": "ucd-addDropdown",
      trigger: ["click"]
    }
  }, [_c("a-button", {
    staticClass: "ucd-eventCard-btn-add",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: function (e) {
        return e.preventDefault();
      }
    }
  }, [_vm._v("\n          添加事件\n        ")]), _vm._v(" "), _c("a-menu", {
    attrs: {
      slot: "overlay"
    },
    slot: "overlay"
  }, _vm._l(_vm.eventList, function (event) {
    return _c("a-menu-item", {
      key: event.id,
      attrs: {
        disabled: event.id in _vm.currentEvents
      },
      on: {
        click: function (e) {
          {
            _vm.addEvent(event.id);
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(event.name) + "\n          ")]);
  }), 1)], 1)], 1) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/EventPanel/EventCardList/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);